export interface Option {
  value: string
  label: string
}

export const buildOptions = (array: any[]) => {
  if (array.length) {
    const options = array.map((val: string) => {
      return { value: val, label: val }
    })
    options.unshift({ value: "", label: "View all" })
    return options
  } else {
    return undefined
  }
}
